export type SocialPlatform = 'linkedin' | 'x' | 'website';

export interface SocialLink {
  readonly platform: SocialPlatform;
  readonly url: string;
}

export interface Speaker {
  readonly id: string;
  readonly eventId: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly headshotUrl: string | null;
  readonly headshotPath: string | null;
  readonly jobTitle: string | null;
  readonly company: string | null;
  readonly bio: string | null;
  readonly socialLinks: ReadonlyArray<SocialLink>;
  readonly sessionIds: ReadonlyArray<string>;
  readonly archived: boolean;
}

export function speakerFullName(
  speaker: Pick<Speaker, 'firstName' | 'lastName'>
): string {
  return `${speaker.firstName} ${speaker.lastName}`.trim();
}
